import posthog from 'posthog-js'

export function usePostHog() {
  posthog.init('phc_3dHKN6YKDn1Q4w19EMH9VSwoXa4SZ1EYIQ3aEZkrJVv', {
    api_host: 'https://eu.i.posthog.com',
    capture_pageview: false,
    persistence: 'localStorage'
  })

  return {
    posthog
  }
}
